import React, { useState } from 'react';
import Header from '../components/Header';
import Analytics from '../components/Analytics';
import TaskModal from '../components/TaskModal';

const AnalyticsPage = () => {
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null);
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <Header search={search} setSearch={setSearch} onAddTask={() => setModal({ type: 'add' })} pageTitle="Analytics" />
      <div className="flex-1 overflow-y-auto scrollbar-thin p-5">
        <Analytics />
      </div>
      {modal && <TaskModal modal={modal} onClose={() => setModal(null)} />}
    </div>
  );
};

export default AnalyticsPage;
